import { Box, useMediaQuery, useTheme } from '@mui/material';
import MenuLogo from 'assets/img/menuLogo.png';
import { useNavigate } from 'react-router-dom';

const NavbarLogo = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('desktop'));

  return (
    <Box
      sx={{
        flex: { mobile: '0 0 auto', tablet: '0 0 auto', desktop: undefined },
        marginBottom: { mobile: 0, tablet: 0, desktop: '20px' },
        marginTop: { mobile: '4px', tablet: '4px', desktop: '40px' },
      }}
    >
      <img
        src={MenuLogo}
        alt="navbarLogo"
        width={isSmallScreen ? '40px' : '50px'}
        style={{
          borderRadius: '8px',
          cursor: 'pointer',
        }}
        onClick={() => navigate('/')}
      />
    </Box>
  );
};

export default NavbarLogo;
